// Productos del cotizador: solo teléfonos del catálogo de la tienda, los más vendibles primero.
import type { CatalogItem } from '@/domains/sales/wizard/types';
import { coincide, terminosDe } from '@/domains/sales/wizard/catalogFilters';
import { isService } from '@/domains/sales/wizard/catalogAvailability';
import { categoryOf } from '@/domains/sales/wizard/cartLines';
import { itemDisplayName } from '@/shared/lib/format/itemDisplayName';

/** Teléfono físico; sin categoría (catálogo anterior) cuenta como teléfono, un servicio nunca. */
export function isPhone(item: CatalogItem): boolean {
    return !isService(item) && categoryOf(item) === 'PHONE';
}

/** Mayor prioridad de venta primero; a igual prioridad, alfabético. */
export function byPopularity(a: CatalogItem, b: CatalogItem): number {
    return (
        (b.salePriority ?? 0) - (a.salePriority ?? 0) ||
        itemDisplayName(a).localeCompare(itemDisplayName(b), 'es-MX') ||
        a.sku.localeCompare(b.sku, 'es-MX')
    );
}

/** Los teléfonos del catálogo, ordenados por popularidad. */
export function quoterPhones(items: CatalogItem[]): CatalogItem[] {
    return items.filter(isPhone).sort(byPopularity);
}

/** Filtra los teléfonos por marca, modelo, capacidad, color o SKU. */
export function searchPhones(phones: CatalogItem[], query: string): CatalogItem[] {
    const terms = terminosDe(query);
    return phones.filter((item) => coincide(item, terms));
}

/** El teléfono con el que arranca: el más popular con piezas, o el más popular si ninguno tiene. */
export function defaultPhone(phones: CatalogItem[]): CatalogItem | null {
    return phones.find((item) => (item.stock ?? 0) > 0) ?? phones.at(0) ?? null;
}
